import React, { useState, useEffect, Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Container, Form, Row, Col } from "react-bootstrap";
import { CircularProgress, SvgIcon } from '@mui/material';
import moment from "moment";
import dayjs from 'dayjs';
import CreditCardDollar from '../icons/creditcard-dollar.svg?react';
import { TextInput, SelectInput, DateInput } from "../../../Helpers/Inputs/index";
import Warning from '../icons/warning.svg?react';
import LightBulb from '../icons/light-bulb.svg?react';
import GetStateListForAflac from '../Helpers/StateListForAflac';
import months, { montListWithMonthNuber } from "../../../Helpers/Lists/Months";
import { InputMaskSSN } from "../../../Helpers/Formatters";
import { object, string, mixed, number as yupnumber, customValidators } from '../../../Helpers/Validators/customValidators';
import GenerateUniqueSSN from '../../../Helpers/Prefill/GenerateUniqueSSN';
import BackNext from '../../Common/SubComponents/BackNext';
import './HIVEligibility.scss';

export default function PaymentInfo(props) {

    const getnameOnAccountOptions = () => {
        const list = []
        var form = { ...props.fullFormState };
        const insuredPersonFullName = `${form.steps.personalInfo.lastName} ${form.steps.personalInfo.firstName} ${form.steps.personalInfo.middleInitial}`;
        const spouseFullName = `${form.steps.spouseInfo.lastName} ${form.steps.spouseInfo.firstName} ${form.steps.spouseInfo.middleInitial}`;
        const showSpouseScreenPlan = ['namedSpousePremium', 'twoParentFamilyPremium'];
        list.push(
            { value: "Name of Proposed Insured", label: insuredPersonFullName },
        );
        if (form.steps.quoter.plan && showSpouseScreenPlan.includes(form.steps.quoter.plan)) {
            list.push({ value: "Name of Spouse", label: spouseFullName })
        }
        list.push({ value: "New Individual", label: "New Individual" });
        return list;
    }

    const getPaymentMethodOptions = () => {
        return (
            [
                { value: "Bank Draft", label: "Bank Draft" },
                { value: "Credit Card", label: "Credit Card" },
            ]
        )
    }


    const getPaymentModeOptions = () => {
        return (
            [
                { value: "Monthly", label: "Monthly" },
                { value: "Quaterly", label: "Quaterly" },
                { value: "Semiannual", label: "Semiannual" },
                { value: "Annual", label: "Annual" },
            ]
        )
    }

    const getExpirationYear = () => {
        const getCurrentYear = new Date().getFullYear();
        const data = [];
        for (let i = getCurrentYear; i <= getCurrentYear + 10; i++) {
            data.push({ value: i, label: i });
        }
        return data;
    }

    const getAccountTypeOptions = () => {
        return (
            [
                { value: "Checking", label: "Checking" },
                { value: "Savings", label: "Savings" },
            ]
        )
    }
    const [isCardExpired, setIsCardExpired] = useState(false);
    const [dateCalenderOpen, setDateCalenderOpen] = useState(false);
    const [routingLoading, setRoutingLoading] = useState('');
    const [hasRoutingNumberError, setHasRoutingNumberError] = useState(false);
    const routingErrorMessage = useRef();

    const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL;

    const formMethods = useForm({
        resolver: yupResolver(PaymentInfo.ValidationSchema),
        mode: 'all',
        reValidateMode: 'all',
        defaultValues: props.formState
    });

    const { handleSubmit, trigger, setValue } = formMethods;
    const checkIsCardExpired = () => {
        const today = new Date();
        if (today.getFullYear() === props.formState.cardExpirationYear && props.formState.cardExpirationMonth !== "") {
            const month = montListWithMonthNuber.find((x => x.label === props.formState.cardExpirationMonth)).value;
            if (month <= today.getMonth()) {
                setIsCardExpired(true);
            }
            else
                setIsCardExpired(false);
        }
        else {
            setIsCardExpired(false);
        }
    }
    useEffect(() => {
        checkIsCardExpired();
    }, [props.formState.cardExpirationYear]);

    useEffect(() => {
        checkIsCardExpired();
    }, [props.formState.cardExpirationMonth]);
    const handleValueChange = (field, value) => {
        props.onFieldChange(field, value);
        trigger(field);
    };

    useEffect(() => {
        if (props.formState.nameOnAccount === "Name of Proposed Insured") {
            handlePayerChange("nameOnAccount", props.formState.nameOnAccount)
        }
    }, []);

    const handlePayerChange = (field, value) => {
        var form = { ...props.fullFormState };
        var firstName, middleName, lastName, street, city, state, zip, email;
        if (value === "Name of Proposed Insured") {
            if (form.steps.personalInfo) {
                firstName = form.steps.personalInfo.firstName;
                middleName = form.steps.personalInfo.middleInitial;
                lastName = form.steps.personalInfo.lastName;
                street = form.steps.personalInfo.street;
                city = form.steps.personalInfo.city;
                state = form.steps.personalInfo.state;
                zip = form.steps.personalInfo.zip;
                email = form.steps.personalInfo.emailAddress;
            }
        }

        if (value === "Name of Spouse") {
            if (form.steps.spouseInfo) {
                firstName = form.steps.spouseInfo.firstName;
                middleName = form.steps.spouseInfo.middleInitial;
                lastName = form.steps.spouseInfo.lastName;
                street = "";
                city = "";
                state = "";
                zip = "";
            }
        }
        form.steps.paymentInfo.accountHolderFirstName = firstName ? firstName : "";
        form.steps.paymentInfo.accountHolderMiddleInitial = middleName ? middleName : "";
        form.steps.paymentInfo.accountHolderLastName = lastName ? lastName : "";
        form.steps.paymentInfo.accountHolderStreet = street ? street : "";
        form.steps.paymentInfo.accountHolderCity = city ? city : "";
        form.steps.paymentInfo.accountHolderState = state ? state : "";
        form.steps.paymentInfo.accountHolderZip = zip ? zip : "";
        form.steps.paymentInfo.nameOnAccount = value;
        form.steps.paymentInfo.accountHolderEmail = email ? email : "";
        setValue('nameOnAccount', value);
        setValue('accountHolderFirstName', firstName);
        setValue('accountHolderMiddleInitial', middleName);
        setValue('accountHolderLastName', lastName);
        setValue('accountHolderStreet', street);
        setValue('accountHolderCity', city);
        setValue('accountHolderState', state);
        setValue('accountHolderZip', zip);
        setValue('accountHolderEmail', email);
        props.onMultiFieldChange(form);

    }
    useEffect(() => {
        if (props.formState.firstDeduction) {
            handleValueChange('draftPreferenceMonth', dayjs(props.formState.firstDeduction).month());
            handleValueChange('draftPreferenceDay', dayjs(props.formState.firstDeduction).date());
        }
    }, [props.formState.firstDeduction])

    const datesToDisabled = (date) => {
        return date.date() === 29 || date.date() === 30 || date.date() === 31;
    }

    const routingNumberCheck = () => {
        setHasRoutingNumberError(false);

        const regex = RegExp(/^[0-9]{9}$/);

        const isValidRouting = regex.test(props.formState.routingNumber);

        if (isValidRouting) {
            setRoutingLoading(<CircularProgress size={25} thickness={4.5} />);

            fetch(`${covrServicesUrl}/api/Aflac/GetBankNameFromRoutingNumber?routingNumber=${props.formState.routingNumber}`)
                .then(res => res.json())
                .then(json => {
                    if (json.success) {
                        setRoutingLoading('');
                    }
                    else if (!json.success) {
                        setHasRoutingNumberError(true);
                        setRoutingLoading('');
                    }
                })
        }
    }

    let debounce = null;
    useEffect(() => {
        let isSubscribed = true;
        if (debounce) {
            clearTimeout(debounce);
        }

        debounce = setTimeout(() => routingNumberCheck(() => isSubscribed), 1000);
        return () => {
            clearTimeout(debounce);
            isSubscribed = false;
        }
    }, [props.formState.routingNumber])

    const onSubmit = () => {

        if (hasRoutingNumberError && props.formState.paymentMethod === "Bank Draft") {
            setTimeout(() => {
                if (routingErrorMessage.current) {
                    window.scrollTo({
                        top: routingErrorMessage.current.offsetTop,
                        behavior: "smooth"
                    });
                }
            }, 100);
            return;
        }
        if (props.formState.paymentMethod === "Credit Card" && isCardExpired)
            return;

        props.onNext();
    };
    const currentMonth = moment().startOf("month").format('MMMM');
    const currentYear = new Date().getFullYear();

    return (
        <Container fluid className='border-class payment-info'>
            <FormProvider {...formMethods}>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row className="justify-content-center pt-3">
                        <Col lg={5}>
                            <div className="text-center mb-2 pt-4"><SvgIcon component={CreditCardDollar} className="small-icons" color="primary" fontSize="large" /></div>
                            <div className="text-center mb-3 form-title">Payment Information</div>

                            <div className='mb-3'>
                                <p className="section-title">Who will be paying for this coverage?</p>
                                <SelectInput
                                    name="nameOnAccount"
                                    id="nameOnAccount"
                                    value={props.formState.nameOnAccount}
                                    onChange={e => handlePayerChange('nameOnAccount', e.target.value)}
                                    label="Insurance Payor"
                                    selectOptions={getnameOnAccountOptions()}
                                />
                            </div>

                            <div className='mb-3'>
                                <p className="section-title">Please choose when you would like to make your first payment. This will also be your coverage effective date.</p>
                                <DateInput
                                    calenderOpen={dateCalenderOpen}
                                    setCalenderOpen={setDateCalenderOpen}
                                    name="firstDeduction"
                                    id="firstDeduction"
                                    label="First deduction"
                                    format="MMMM D, YYYY"
                                    value={props.formState.firstDeduction ? dayjs(props.formState.firstDeduction) : null}
                                    onChange={value => handleValueChange('firstDeduction', value)}
                                    minDate={dayjs().add(1, 'days')}
                                    maxDate={dayjs().add(1, 'M')}
                                    shouldDisableDate={datesToDisabled}
                                    fullWidth
                                    InputProps={{ readOnly: true }}
                                />
                            </div>

                            <Row>
                                <p className='tip-box mx-3'>
                                    <b className='inside-title'>
                                        <SvgIcon component={Warning} fontSize="large" className='inside-icon' />
                                        Important:{' '}
                                    </b>
                                    <b className='inside-text'>Your policy will become effective upon the draft of your first premium payment. Your payment will then be drafted on this date each month.</b>
                                </p>
                            </Row>

                            {props.formState.nameOnAccount === "New Individual" &&
                                <Fragment>
                                    <p className="section-title"><b>Payor Information</b></p>
                                    <div className='mb-3'>
                                        <TextInput
                                            name="accountHolderFirstName"
                                            id="accountHolderFirstName"
                                            label="First Name"
                                            value={props.formState.accountHolderFirstName}
                                            onChange={e => handleValueChange('accountHolderFirstName', e.target.value)}
                                        />
                                    </div>

                                    <div className='mb-3'>
                                        <TextInput
                                            name="accountHolderMiddleInitial"
                                            id="accountHolderMiddleInitial"
                                            label="Middle Initial"
                                            value={props.formState.accountHolderMiddleInitial}
                                            onChange={e => handleValueChange('accountHolderMiddleInitial', e.target.value)}
                                        />
                                    </div>

                                    <div className='mb-3'>
                                        <TextInput
                                            name="accountHolderLastName"
                                            id="accountHolderLastName"
                                            label="Last Name"
                                            value={props.formState.accountHolderLastName}
                                            onChange={e => handleValueChange('accountHolderLastName', e.target.value)}
                                        />
                                    </div>
                                </Fragment>
                            }

                            {props.formState.nameOnAccount && props.formState.nameOnAccount !== "Name of Proposed Insured" &&
                                <Fragment>
                                    <p className="section-title"><b>Street Address</b></p>
                                    <div className='mb-3'>
                                        <TextInput
                                            name="accountHolderStreet"
                                            id="accountHolderStreet"
                                            label="Street Address"
                                            value={props.formState.accountHolderStreet}
                                            onChange={e => handleValueChange('accountHolderStreet', e.target.value)}
                                        />
                                    </div>

                                    <div className='mb-3'>
                                        <TextInput
                                            name="accountHolderCity"
                                            id="accountHolderCity"
                                            label="City"
                                            value={props.formState.accountHolderCity}
                                            onChange={e => handleValueChange('accountHolderCity', e.target.value)}
                                        />
                                    </div>

                                    <Row>
                                        <Col>
                                            <div className='mb-3'>
                                                <SelectInput
                                                    name="accountHolderState"
                                                    id="accountHolderState"
                                                    value={props.formState.accountHolderState}
                                                    onChange={(e) => handleValueChange('accountHolderState', e.target.value)}
                                                    label="State"
                                                    selectOptions={GetStateListForAflac()}
                                                />
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className='mb-3'>
                                                <TextInput
                                                    name="accountHolderZip"
                                                    id="accountHolderZip"
                                                    label="Zip"
                                                    value={props.formState.accountHolderZip}
                                                    onChange={e => handleValueChange('accountHolderZip', e.target.value)}
                                                    inputProps={{
                                                        maxLength: 5,
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>

                                    <div className='mb-3'>
                                        <TextInput
                                            name="accountHolderEmail"
                                            id="accountHolderEmail"
                                            label="Email address"
                                            value={props.formState.accountHolderEmail}
                                            onChange={e => handleValueChange('accountHolderEmail', e.target.value)}
                                        />
                                    </div>

                                </Fragment>
                            }

                            <p className="section-title"><b>Payment Account Details</b></p>

                            <div className='mb-3'>
                                <SelectInput
                                    name="paymentMethod"
                                    id="paymentMethod"
                                    value={props.formState.paymentMethod}
                                    onChange={(e) => handleValueChange('paymentMethod', e.target.value)}
                                    label="Payment Method"
                                    selectOptions={getPaymentMethodOptions()}
                                />
                            </div>

                            <div className='mb-3' hidden>
                                <SelectInput
                                    name="paymentMode"
                                    id="paymentMode"
                                    value={props.formState.paymentMode ? props.formState.paymentMode : "Monthly"}
                                    onChange={(e) => handleValueChange('paymentMode', e.target.value)}
                                    label="Payment Mode"
                                    selectOptions={getPaymentModeOptions()}
                                />
                            </div>

                            {props.formState.paymentMethod === "Credit Card" &&
                                <Fragment>
                                    <div className='mb-3'>
                                        <TextInput
                                            name="cardNumber"
                                            id="cardNumber"
                                            label="Card Number"
                                            value={props.formState.cardNumber}
                                            onChange={e => handleValueChange('cardNumber', e.target.value)}
                                            inputProps={{
                                                maxLength: 16,
                                            }}
                                        />
                                    </div>

                                    <Row>
                                        <Col sm={6} className='w-100'>
                                            <div className='mb-3'>
                                                <SelectInput
                                                    name="cardExpirationMonth"
                                                    id="cardExpirationMonth"
                                                    value={props.formState.cardExpirationMonth}
                                                    onChange={(e) => handleValueChange('cardExpirationMonth', e.target.value)}
                                                    label="Exp Month"
                                                    selectOptions={months()}
                                                />
                                            </div>
                                        </Col>
                                        <Col sm={6} className='w-100'>
                                            <div className='mb-3'>
                                                <SelectInput
                                                    name="cardExpirationYear"
                                                    id="cardExpirationYear"
                                                    value={props.formState.cardExpirationYear}
                                                    onChange={(e) => handleValueChange('cardExpirationYear', e.target.value)}
                                                    label="Exp Year"
                                                    selectOptions={getExpirationYear()}
                                                />
                                            </div>
                                        </Col>
                                        <Col sm={12} className="text-center mb-3">
                                            {isCardExpired && <span className="text-danger">Your card is expired. Please input a valid card expiring after {currentMonth} {currentYear}</span>}
                                        </Col>
                                    </Row>
                                </Fragment>
                            }

                            {props.formState.paymentMethod === "Bank Draft" &&
                                <Fragment>
                                    <div className='mb-3'>
                                        <TextInput
                                            name="routingNumber"
                                            id="routingNumber"
                                            label="Routing Number"
                                            value={props.formState.routingNumber}
                                            onChange={e => handleValueChange('routingNumber', e.target.value)}
                                            inputProps={{
                                                maxLength: 9,
                                            }}
                                            InputProps={{
                                                endAdornment: routingLoading
                                            }}
                                        />
                                    </div>

                                    {hasRoutingNumberError && (
                                        <div ref={routingErrorMessage} className="text-danger text-center mb-3">Unable to verify routing number.</div>
                                    )}

                                    <div className='mb-3'>
                                        <TextInput
                                            name="accountNumber"
                                            id="accountNumber"
                                            label="Account Number"
                                            value={props.formState.accountNumber}
                                            onChange={e => handleValueChange('accountNumber', e.target.value)}
                                            inputProps={{
                                                maxLength: 17,
                                            }}
                                        />
                                    </div>

                                    <div className='mb-3'>
                                        <SelectInput
                                            name="accountType"
                                            id="accountType"
                                            value={props.formState.accountType}
                                            onChange={(e) => handleValueChange('accountType', e.target.value)}
                                            label="Account Type"
                                            selectOptions={getAccountTypeOptions()}
                                        />
                                    </div>
                                </Fragment>
                            }

                            <Row>
                                <p className='tip-box mx-3'>
                                    <b className='inside-title'>
                                        <SvgIcon component={LightBulb} fontSize="large" className='inside-icon' />
                                        Insider Tip:{' '}
                                    </b>
                                    <b className='inside-text'>This site is completely secure though 256bit TLS encryption. All necessary precautions and technologies have been put in place to protect our customers and their personal information.</b>
                                </p>
                            </Row>

                            <div className='mb-3'>
                                <TextInput
                                    name="socialSecurityNumber"
                                    id="socialSecurityNumber"
                                    label="Social Security Number"
                                    value={props.formState.socialSecurityNumber}
                                    onChange={e => handleValueChange('socialSecurityNumber', e.target.value)}
                                    InputProps={{
                                        inputComponent: InputMaskSSN,
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>

                    <div className='backnext-wrapper'>
                        <BackNext onBack={props.onBack} isAflac={true} continueLabel={{ text: "Next" }} nextDisabled={routingLoading} />
                    </div>
                </Form>
            </FormProvider>
        </Container >
    );
}

PaymentInfo.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func,
    onFieldChange: PropTypes.func.isRequired,
    onBack: PropTypes.func,
};

PaymentInfo.ValidationSchema = object().shape({
    nameOnAccount: string().required('Account Holder is required.'),
    dependentChild: yupnumber().when('selectPrimary', {
        is: "Dependent Child",
        then: (schema) => schema.required("Dependent child is required."),
        otherwise: (schema) => schema.notRequired()
    }),
    firstDeduction: mixed().nullable().required("First Deduction date is required.").test({
        message: "Invalid Date",
        test: (value) => value && dayjs(value).isValid()
    }).typeError("Invalid date"),
    accountHolderFirstName: string().when('nameOnAccount', {
        is: "New Individual",
        then: (schema) => schema.required("First Name is required."),
        otherwise: (schema) => schema.notRequired()
    }),
    accountHolderMiddleInitial: customValidators.string().when('nameOnAccount', {
        is: "New Individual",
        then: (schema) => schema.isValidNameWithFiftyChar('Middle Initials is required', false),
        otherwise: (schema) => schema.notRequired()
    }),
    accountHolderLastName: string().when('nameOnAccount', {
        is: "New Individual",
        then: (schema) => schema.required("Last Name is required."),
        otherwise: (schema) => schema.notRequired()
    }),
    accountHolderStreet: string().when('nameOnAccount', {
        is: (nameOnAccount) => nameOnAccount !== "Name of Proposed Insured",
        then: (schema) => schema.required("Street is required."),
        otherwise: (schema) => schema.notRequired()
    }),
    accountHolderCity: string().when('nameOnAccount', {
        is: (nameOnAccount) => nameOnAccount !== "Name of Proposed Insured",
        then: (schema) => schema.required("City is required."),
        otherwise: (schema) => schema.notRequired()
    }),
    accountHolderState: string().when('nameOnAccount', {
        is: (nameOnAccount) => nameOnAccount !== "Name of Proposed Insured",
        then: (schema) => schema.required("State is required."),
        otherwise: (schema) => schema.notRequired()
    }),
    accountHolderZip: string().when('nameOnAccount', {
        is: (nameOnAccount) => nameOnAccount !== "Name of Proposed Insured",
        then: (schema) => schema.required("Zip is required."),
        otherwise: (schema) => schema.notRequired()
    }),
    accountHolderEmail: string().when('nameOnAccount', {
        is: (nameOnAccount) => nameOnAccount !== "Name of Proposed Insured",
        then: (schema) => schema
            .email('Email address must be valid.')
            .notRequired(),
        otherwise: (schema) => schema.notRequired()
    }),
    paymentMethod: string().required("Payment Method is required."),
    cardNumber: customValidators.string().when('paymentMethod', {
        is: "Credit Card",
        then: (schema) => schema
            .isValidCreditCardType('Aflac will only accept Visa, Mastercard and American Express. Please submit using a valid card type.', 'cardNumber'),
        otherwise: (schema) => schema.notRequired()
    }),
    cardExpirationMonth: string().when('paymentMethod', {
        is: "Credit Card",
        then: (schema) => schema.required("Card Expiration Month is required."),
        otherwise: (schema) => schema.notRequired()
    }),
    cardExpirationYear: string().when('paymentMethod', {
        is: "Credit Card",
        then: (schema) => schema.required("Card Expiration Year is required."),
        otherwise: (schema) => schema.notRequired()
    }),
    routingNumber: string().when('paymentMethod', {
        is: "Bank Draft",
        then: (schema) => schema.required('Routing Number is required.')
            .matches(/^[0-9]{9}$/, 'The routing number must be 9 digits in length.'),
        otherwise: (schema) => schema.notRequired()
    }),
    accountNumber: string().when('paymentMethod', {
        is: "Bank Draft",
        then: (schema) => schema.required('Account Number is required.')
            .matches(/^[0-9]{4,17}$/, 'The account number must be between 4 and 17 digits in length.'),
        otherwise: (schema) => schema.notRequired()
    }),
    accountType: string().when('paymentMethod', {
        is: "Bank Draft",
        then: (schema) => schema.required("Account Type is required."),
        otherwise: (schema) => schema.notRequired()
    }),
    socialSecurityNumber: string()
        .required('Social Security Number is required.')
        .matches(/\d{3}-\d{2}-\d{4}/, 'Social Security Number must be formatted as "123-45-6789".'),
});

PaymentInfo.DefaultFormState = (prefill = false) => {
    return {
        nameOnAccount: 'Name of Proposed Insured',
        dependentChild: 1,
        firstDeduction: null,
        accountHolderFirstName: prefill ? 'Props' : '',
        accountHolderMiddleInitial: prefill ? 'N' : '',
        accountHolderLastName: prefill ? "Sured" : '',
        accountHolderStreet: prefill ? "2020 Covr St" : '',
        accountHolderCity: prefill ? "Boise" : '',
        accountHolderState: prefill ? "CA" : '',
        accountHolderZip: prefill ? "83702" : '',
        accountHolderEmail: prefill ? 'user@address.com' : '',
        paymentMethod: prefill ? 'Credit Card' : '',
        paymentMode: 'Monthly',
        cardNumber: prefill ? '12345678910' : '',
        cardExpirationMonth: prefill ? 'january' : '',
        cardExpirationYear: prefill ? '2023' : '',
        routingNumber: prefill ? '081218879' : '',
        accountNumber: prefill ? '11111111112' : '',
        accountType: prefill ? 'Savings' : '',
        socialSecurityNumber: prefill ? GenerateUniqueSSN('444') : "",
    };
};
